/* Scentimental Bundle Picker Pro
   Trigger buttons + drawer with search/filter/cards.
   Selections are written back into the Simple Bundles app's hidden <select>s so
   the existing inventory/out-of-stock/add-to-cart logic keeps working unchanged.
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  function relocatePicker(root, drawer) {
    // Try to find the cart-add form (Simple Bundles puts its UI inside it).
    // Look for the form's add-to-cart button and put the picker right above it.
    function attempt() {
      var form = document.querySelector(
        'form[action$="/cart/add"]:not([id^="product-form-installment"])'
      );
      if (!form) return false;

      var anchor = form.querySelector('product-variant-picker')
        || form.querySelector('[data-buy-buttons]')
        || form.querySelector('button[type="submit"]')
        || form.querySelector('input[type="submit"]');

      if (!anchor) return false;

      // Move the picker (but NOT the drawer, drawer is fixed-position and
      // lives at the body level)
      if (drawer.parentNode === root) {
        document.body.appendChild(drawer);
      }
      var insertParent = anchor.parentNode;
      if (insertParent && root.parentNode !== insertParent) {
        insertParent.insertBefore(root, anchor);
      }
      return true;
    }

    if (attempt()) return;
    // Retry a few times in case Simple Bundles app needs time to render
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      if (attempt() || tries > 30) clearInterval(interval);
    }, 300);
  }

  function init() {
    var roots = document.querySelectorAll('[data-section-type="bundle-picker-pro"]');
    if (!roots.length) return;
    roots.forEach(initOne);
  }

  function initOne(root) {
    var sectionId = root.getAttribute('data-section-id');
    var slotCount = parseInt(root.getAttribute('data-slot-count'), 10);
    var targetSize = parseInt(root.getAttribute('data-target-size'), 10) || slotCount;

    var drawer = root.querySelector('[data-bpp-drawer]');
    if (!drawer) return;

    // Relocate the picker into the product form, right before the
    // "Choose All Options" / "Add to Cart" button. This way the picker
    // appears in the natural product-purchase flow regardless of where the
    // section sits in the template's section order.
    relocatePicker(root, drawer);

    // Sort cards alphabetically within each slot panel (server-side they come
    // out in metafield-definition order). Query the DRAWER not the root,
    // because relocatePicker has moved the drawer to document.body.
    drawer.querySelectorAll('.bpp__slot-cards').forEach(function (panel) {
      var cards = Array.from(panel.querySelectorAll('[data-bpp-card]'));
      cards.sort(function (a, b) {
        var ta = (a.getAttribute('data-search') || '').trim();
        var tb = (b.getAttribute('data-search') || '').trim();
        return ta.localeCompare(tb);
      });
      var empty = panel.querySelector('.bpp__empty');
      cards.forEach(function (c) { panel.insertBefore(c, empty); });
    });

    // Kick off lazy-load of images + tags for the cards in THIS picker's
    // drawer (must happen after sort + relocate so we have a stable DOM).
    // Image lazy-load removed — text-only cards now

    var searchInput = drawer.querySelector('[data-bpp-search]');
    var tabs = drawer.querySelectorAll('[data-bpp-tab]');
    var slotPanels = drawer.querySelectorAll('[data-bpp-slot]');
    var triggers = root.querySelectorAll('[data-bpp-trigger]');
    var closeButtons = drawer.querySelectorAll('[data-bpp-close]');

    // Per-slot selected value, mirrors the Simple Bundles option values
    var selections = new Array(slotCount).fill(null);
    var activeSlot = 0;
    var activeTab = 'all';

    /* ── Helpers ────────────────────────────── */

    function findAppSelect(slotName) {
      // Simple Bundles renders selects with id derived from option name
      // (downcased, spaces → dashes), inside #simple-bundles-options
      var id = (slotName || '').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      var selector = '#simple-bundles-options #' + CSS.escape(id) +
                     ', #simple-bundles-io-options #' + CSS.escape(id);
      var sel = document.querySelector(selector);
      if (sel) return sel;
      // Fallback: scan all selects by their label text
      var allSelects = document.querySelectorAll('#simple-bundles-options select, #simple-bundles-io-options select');
      for (var i = 0; i < allSelects.length; i++) {
        var label = document.querySelector('label[for="' + allSelects[i].id + '"]');
        if (label && label.textContent.trim() === slotName) return allSelects[i];
      }
      return null;
    }

    function setAppSelectValue(slotName, value) {
      var sel = findAppSelect(slotName);
      if (!sel) return;
      // Make sure the option exists
      var has = Array.from(sel.options).some(function (o) { return o.value === value; });
      if (!has) {
        // Add the option dynamically (in case the app hasn't rendered it yet)
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        sel.appendChild(opt);
      }
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function openDrawer(slotIndex) {
      activeSlot = slotIndex;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      // Force reflow then add open class for transition
      drawer.getBoundingClientRect();
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      // Show the matching slot's cards, hide others
      slotPanels.forEach(function (p) {
        var idx = parseInt(p.getAttribute('data-bpp-slot'), 10);
        p.hidden = (idx !== slotIndex);
      });

      // Update the drawer title + eyebrow per slot
      var slotEl = root.querySelectorAll('.bpp__slot')[slotIndex];
      var slotName = slotEl ? (slotEl.getAttribute('data-slot-name') || '') : '';
      var titleEl = drawer.querySelector('[data-bpp-title]');
      var eyebrowEl = drawer.querySelector('[data-bpp-eyebrow]');
      var ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth'];
      var ordinal = ordinals[slotIndex] || ('#' + (slotIndex + 1));
      if (eyebrowEl) eyebrowEl.textContent = 'Step ' + (slotIndex + 1) + ' of ' + slotCount;
      if (titleEl) {
        // Prefer the slot's own name from the bundle (it's already meaningful);
        // fall back to "Choose Your <Nth> Fragrance" if name is empty.
        titleEl.textContent = slotName || ('Choose Your ' + ordinal + ' Fragrance');
      }

      // Reset filters when opening a fresh slot
      if (searchInput) searchInput.value = '';
      activeTab = 'all';
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-bpp-tab') === 'all'); });

      applyFilters();
      markSelectedCards();
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 220);

      // Filter out draft/archived products on first open of each slot.
      // Checks /products/{handle}.json — 404 or no published_at = remove card.
      if (window._bppFilterDrafts) {
        var panel = drawer.querySelector('[data-bpp-slot="' + slotIndex + '"]');
        if (panel) window._bppFilterDrafts(panel);
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 280);
    }

    function applyFilters() {
      var q = (searchInput && searchInput.value || '').trim().toLowerCase();
      var activePanel = drawer.querySelector('[data-bpp-slot][hidden="false"], [data-bpp-slot]:not([hidden])');
      if (!activePanel) {
        slotPanels.forEach(function (p) {
          if (parseInt(p.getAttribute('data-bpp-slot'), 10) === activeSlot) activePanel = p;
        });
      }
      if (!activePanel) return;

      var cards = activePanel.querySelectorAll('[data-bpp-card]');
      var visibleCount = 0;
      cards.forEach(function (card) {
        var matchTab = true;
        if (activeTab === 'female') matchTab = card.getAttribute('data-gender') === 'female';
        else if (activeTab === 'male') matchTab = card.getAttribute('data-gender') === 'male';
        else if (activeTab === 'unisex') matchTab = card.getAttribute('data-gender') === 'unisex';
        else if (activeTab === 'new') matchTab = card.getAttribute('data-new') === 'true';
        else if (activeTab === 'bestseller') matchTab = card.getAttribute('data-bestseller') === 'true';

        var matchSearch = !q || (card.getAttribute('data-search') || '').indexOf(q) !== -1;
        var show = matchTab && matchSearch;
        card.hidden = !show;
        if (show) visibleCount++;
      });

      var empty = activePanel.querySelector('.bpp__empty');
      if (empty) empty.hidden = visibleCount > 0;
    }

    function markSelectedCards() {
      slotPanels.forEach(function (p) {
        var idx = parseInt(p.getAttribute('data-bpp-slot'), 10);
        var selVal = selections[idx];
        p.querySelectorAll('[data-bpp-card]').forEach(function (c) {
          var isSel = selVal !== null && c.getAttribute('data-value') === selVal;
          c.classList.toggle('is-selected', isSel);
          var btn = c.querySelector('[data-bpp-add]');
          if (btn) btn.textContent = isSel ? 'Selected ✓' : 'Add +';
        });
      });
    }

    function updateTrigger(slotIndex, value, title) {
      var slot = root.querySelectorAll('.bpp__slot')[slotIndex];
      if (!slot) return;
      slot.classList.toggle('is-filled', !!value);
      var selSpan = slot.querySelector('.bpp__trigger-selected');
      if (selSpan) {
        if (value) {
          selSpan.textContent = title || value;
          selSpan.hidden = false;
        } else {
          selSpan.textContent = '';
          selSpan.hidden = true;
        }
      }
      var clearBtn = slot.querySelector('[data-bpp-clear]');
      if (clearBtn) clearBtn.hidden = !value;
    }

    function refreshProgress() {
      var count = selections.filter(function (v) { return v !== null; }).length;
      var pct = Math.min(100, Math.round((count / targetSize) * 100));
      root.querySelectorAll('.bpp__progress-count').forEach(function (el) { el.textContent = count; });
      root.querySelectorAll('.bpp__progress-target').forEach(function (el) { el.textContent = targetSize; });
      // Drive the progress bar via CSS variable for reliability
      root.style.setProperty('--bpp-progress', pct + '%');
      // Drawer footer mirror
      drawer.querySelectorAll('.bpp__progress-count').forEach(function (el) { el.textContent = count; });
    }

    /* ── Wire events ────────────────────────── */

    triggers.forEach(function (btn, i) {
      btn.addEventListener('click', function () { openDrawer(i); });
    });

    // Wire the clear (×) buttons on each slot
    var clearBtns = root.querySelectorAll('[data-bpp-clear]');
    clearBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        // Empty the selection for this slot
        selections[i] = null;
        // Reset the underlying Simple Bundles app select to its placeholder
        var slotEl = root.querySelectorAll('.bpp__slot')[i];
        var slotName = slotEl ? slotEl.getAttribute('data-slot-name') : '';
        var sel = findAppSelect(slotName);
        if (sel) {
          sel.selectedIndex = 0;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateTrigger(i, null, '');
        refreshProgress();
        markSelectedCards();
      });
    });

    closeButtons.forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });

    if (searchInput) {
      var to;
      searchInput.addEventListener('input', function () {
        clearTimeout(to);
        to = setTimeout(applyFilters, 100);
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        activeTab = t.getAttribute('data-bpp-tab');
        applyFilters();
      });
    });

    // Add button delegation
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bpp-add]');
      if (!btn) return;
      var card = btn.closest('[data-bpp-card]');
      if (!card) return;
      var value = card.getAttribute('data-value');
      var title = (card.querySelector('.bpp__card-title') || {}).textContent;

      // Record selection
      selections[activeSlot] = value;

      // Tell the Simple Bundles app via its hidden select
      var slotEl = root.querySelectorAll('.bpp__slot')[activeSlot];
      var slotName = slotEl ? slotEl.getAttribute('data-slot-name') : '';
      setAppSelectValue(slotName, value);

      // Visual updates
      updateTrigger(activeSlot, value, title);
      refreshProgress();
      markSelectedCards();

      // Auto-close + auto-advance to next empty slot if any
      setTimeout(function () {
        closeDrawer();
        var nextEmpty = selections.findIndex(function (v) { return v === null; });
        if (nextEmpty !== -1 && nextEmpty !== activeSlot) {
          setTimeout(function () { openDrawer(nextEmpty); }, 320);
        }
      }, 300);
    });

    // Initial progress render
    refreshProgress();

    // Themed Discovery Sets and similar curated bundles have exactly 1 option
    // per slot. Forcing the customer to "choose" the only available option in
    // every slot is friction with no upside — pre-fill all single-option slots
    // so they land on the page with the bundle ready and just hit Add to Cart.
    var autoFilledAny = false;
    slotPanels.forEach(function (panel) {
      var idx = parseInt(panel.getAttribute('data-bpp-slot'), 10);
      if (selections[idx] !== null) return;
      var cards = Array.from(panel.querySelectorAll('[data-bpp-card]'));
      if (cards.length !== 1) return;
      var card = cards[0];
      var value = card.getAttribute('data-value');
      var titleEl = card.querySelector('.bpp__card-title');
      var title = titleEl ? titleEl.textContent : value;
      var slotEl = root.querySelectorAll('.bpp__slot')[idx];
      var slotName = slotEl ? slotEl.getAttribute('data-slot-name') : '';
      selections[idx] = value;
      setAppSelectValue(slotName, value);
      updateTrigger(idx, value, title);
      autoFilledAny = true;
    });
    if (autoFilledAny) {
      refreshProgress();
      markSelectedCards();
    }

    // Simple Bundles' setDefaultOptions() auto-fills every <select> with its
    // first real option (not the placeholder) on init, which would otherwise
    // make ALL slots appear "selected" before the customer has chosen
    // anything. We reset the app's selects back to the placeholder, but only
    // while the customer hasn't interacted yet — once they start picking,
    // their choices (written to the app's selects via setAppSelectValue) are
    // sacred and must not be wiped.
    //
    // If we auto-filled single-option slots above, treat that as the user's
    // implicit interaction so the reset timeouts below do not undo our work.
    var userHasInteracted = autoFilledAny;
    function resetAppSelects() {
      if (userHasInteracted) return;
      var triggerEls = root.querySelectorAll('.bpp__slot');
      triggerEls.forEach(function (slot) {
        var slotName = slot.getAttribute('data-slot-name');
        var sel = findAppSelect(slotName);
        if (sel) {
          sel.selectedIndex = 0; // placeholder
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    // Run a few times because the app's own init also runs on a timeout
    [400, 1000, 1800, 3000].forEach(function (ms) { setTimeout(resetAppSelects, ms); });

    // Auto-filled slots (themed Discovery Sets) get clobbered by Simple Bundles'
    // setDefaultOptions() — it runs after our init and resets every select to its
    // placeholder, breaking the add-to-cart validator even though our internal
    // selections array is fine. Re-apply our values on the same cadence as the
    // resets above so the hidden selects survive whichever order the app inits.
    function reapplyAutoFill() {
      if (!autoFilledAny) return;
      selections.forEach(function (value, idx) {
        if (value === null) return;
        var slotEl = root.querySelectorAll('.bpp__slot')[idx];
        var slotName = slotEl ? slotEl.getAttribute('data-slot-name') : '';
        if (slotName) setAppSelectValue(slotName, value);
      });
    }
    [600, 1200, 2000, 3500].forEach(function (ms) { setTimeout(reapplyAutoFill, ms); });

    // Mark interacted on the first user pick so subsequent resets are no-ops
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-bpp-add]')) userHasInteracted = true;
    }, true);

    // Clearing a slot via the (×) button means the customer overrode auto-fill —
    // stop re-applying that slot. selections[idx] is already set to null by the
    // clear handler, so reapplyAutoFill naturally skips it.
  }

  ready(init);

  /* ── Lazy-load product image + tags per card ─────────
     Called when a card enters the viewport. Uses Shopify's storefront
     /products/{handle}.json (public, no auth) so we don't hit the
     all_products[] cap. Results are cached in sessionStorage so re-opening
     the drawer is instant.
  */
  var enhanceCard = (function () {
    var cache = {};
    try {
      var saved = sessionStorage.getItem('bpp_card_cache');
      if (saved) cache = JSON.parse(saved);
    } catch (_) { /* ignore */ }

    function saveCache() {
      try { sessionStorage.setItem('bpp_card_cache', JSON.stringify(cache)); } catch (_) {}
    }

    function apply(card, data) {
      if (!card) return;
      var img = card.querySelector('[data-bpp-img]');
      if (img && data.image) { img.src = data.image; }

      var gender = 'unisex';
      var tags = (data.tags || '').toLowerCase();
      if (tags.indexOf('female') !== -1) gender = 'female';
      else if (tags.indexOf('male') !== -1) gender = 'male';
      if (tags.indexOf('unisex') !== -1) gender = 'unisex';

      var bestseller = /bestseller|best[- ]?seller/.test(tags);
      var isNew = /newly[- ]added|new arrival/.test(tags);

      card.setAttribute('data-gender', gender);
      card.setAttribute('data-bestseller', bestseller ? 'true' : 'false');
      card.setAttribute('data-new', isNew ? 'true' : 'false');

      var pills = card.querySelector('[data-bpp-pills]');
      if (pills) {
        pills.innerHTML = '<span class="bpp__pill bpp__pill--' + gender + '">' + gender + '</span>' +
          (isNew ? '<span class="bpp__pill bpp__pill--new">New</span>' : '');
      }
      var bs = card.querySelector('[data-bpp-bestseller]');
      if (bs) bs.hidden = !bestseller;
    }

    function fetchAndApply(card) {
      var handle = card.getAttribute('data-handle');
      if (!handle || card.dataset.bppLoaded === '1') return;
      card.dataset.bppLoaded = '1';

      if (cache[handle]) { apply(card, cache[handle]); return; }

      fetch('/products/' + handle + '.json', { cache: 'force-cache' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.product) return;
          var p = d.product;
          var data = {
            image: p.image ? p.image.src : ((p.images || [])[0] || {}).src,
            tags: p.tags || ''
          };
          cache[handle] = data;
          saveCache();
          apply(card, data);
        })
        .catch(function () { /* network blip, leave placeholder */ });
    }

    // Set up an IntersectionObserver per drawer body
    function observe(rootScope) {
      var bodyEl = rootScope.querySelector('.bpp__drawer-body');
      if (!bodyEl || !('IntersectionObserver' in window)) {
        // Fallback: just enhance everything
        rootScope.querySelectorAll('[data-bpp-card]').forEach(fetchAndApply);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            fetchAndApply(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { root: bodyEl, rootMargin: '200px' });

      rootScope.querySelectorAll('[data-bpp-card]').forEach(function (c) {
        io.observe(c);
      });
    }

    return { observe: observe };
  })();

  // Expose the enhancer so initOne can call it on the drawer (the drawer gets
  // moved to document.body, so the picker init knows where it actually lives
  // and can pass the correct DOM scope).
  window._bppEnhanceObserve = function (scope) {
    enhanceCard.observe(scope);
  };

  // Stagger fetches so we don't fire 800 requests at once. Process up to 8
  // concurrent. Called when a drawer slot panel becomes visible.
  window._bppFetchAll = function (panel) {
    var cards = Array.from(panel.querySelectorAll('[data-bpp-card]'));
    var queue = cards.filter(function (c) { return c.dataset.bppLoaded !== '1'; });
    if (!queue.length) return;
    var concurrency = 8;
    var inflight = 0;
    var idx = 0;
    function next() {
      while (inflight < concurrency && idx < queue.length) {
        var card = queue[idx++];
        if (!card) continue;
        inflight++;
        var handle = card.getAttribute('data-handle');
        if (!handle) { inflight--; continue; }
        if (card.dataset.bppLoaded === '1') { inflight--; continue; }
        card.dataset.bppLoaded = '1';
        fetch('/products/' + handle + '.json', { cache: 'force-cache' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then((function (c) {
            return function (d) {
              inflight--;
              if (!d || !d.product) { next(); return; }
              var p = d.product;
              var img = c.querySelector('[data-bpp-img]');
              if (img) {
                var src = (p.image && p.image.src) || ((p.images || [])[0] || {}).src;
                if (src) img.src = src;
              }
              next();
            };
          })(card))
          .catch(function () { inflight--; next(); });
      }
    }
    next();
  };

  // Filter out draft / archived products from a slot panel. A product that
  // is set to "Draft" status in Shopify admin returns 404 from the public
  // /products/{handle}.json endpoint; an "Archived" product returns 200 but
  // with published_at: null. Either way, we want it gone from the picker.
  // Results are cached in sessionStorage so we don't refetch on every open.
  window._bppFilterDrafts = function (panel) {
    if (!panel || panel.dataset.bppFiltered === '1') return;
    panel.dataset.bppFiltered = '1';

    var cache = {};
    try { cache = JSON.parse(sessionStorage.getItem('bpp_active_cache') || '{}'); } catch (_) {}

    var cards = Array.from(panel.querySelectorAll('[data-bpp-card]'));
    var concurrency = 6;
    var inflight = 0;
    var idx = 0;

    function saveCache() {
      try { sessionStorage.setItem('bpp_active_cache', JSON.stringify(cache)); } catch (_) {}
    }

    function processNext() {
      while (inflight < concurrency && idx < cards.length) {
        var card = cards[idx++];
        var handle = card.getAttribute('data-handle');
        if (!handle) continue;

        // Cache hit
        if (handle in cache) {
          if (!cache[handle]) card.remove();
          continue;
        }

        inflight++;
        (function (c, h) {
          fetch('/products/' + h + '.json', { cache: 'force-cache' })
            .then(function (r) {
              if (r.status === 404) { return { active: false }; }
              if (!r.ok) { return { active: true }; } // be permissive on transient errors
              return r.json().then(function (d) {
                var active = !!(d && d.product && d.product.published_at);
                return { active: active };
              });
            })
            .then(function (result) {
              cache[h] = result.active;
              saveCache();
              if (!result.active) c.remove();
            })
            .catch(function () {
              // Network blip — leave card visible so we don't accidentally hide everything
            })
            .then(function () {
              inflight--;
              processNext();
            });
        })(card, handle);
      }
    }
    processNext();
  };

  /* Bundle review badge override has moved to assets/bundle-review-badge.js
     which runs globally and overrides by product-ID match — same behaviour
     on PDPs plus also covers collection cards where Fera injects badges
     dynamically after page load. */
})();
